import React, { useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'

export default function LoadingSpinner({
  className = '',
}) {
  const [showLoader, setShowLoader] = useState(false)

  useEffect(() => {
    const x = setTimeout(() => {
      setShowLoader(true)
    }, 500) //0.5 seconds

    return () => {
      clearTimeout(x)
    }
  }, [])

  return (
    <>
      {showLoader && (
        <>
          <div className={`p-3 text-center ${className}`}>
            <Spinner animation='grow' />
          </div>
        </>
      )}
    </>
  )
}
